var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardDoctor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_17",
    "data-name": "Layer 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 254.417,
    height: 215.666,
    viewBox: "0 0 254.417 215.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M232.473,87.135a5.5,5.5,0,1,1-7.774,0A5.5,5.5,0,0,1,232.473,87.135Z",
    transform: "translate(-223.088 -85.525)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 5.497,
    cy: 5.497,
    r: 5.497,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13",
    "data-name": "Layer 13",
    transform: "translate(27.323 80.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(78.786 4.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M215.793,261.425h22.963V155.311h-6.978L216.7,142.221Z",
    transform: "translate(-215.793 -142.221)",
    fill: "#ffcb57"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(97.096 3.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M264.1,260.226H241.14V154.112h6.978l15.075-13.091Z",
    transform: "translate(-241.14 -141.022)",
    fill: "#eaa824"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(0 13.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M183.918,273.595H114.555s-7.824-10.792-7.824-19.965,23.742-71.309,31.836-78.267,45.351-21.091,45.351-21.091Z",
    transform: "translate(-106.731 -154.272)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    transform: "translate(118.54 13.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M270.824,273.595H346.4s7.824-10.792,7.824-19.965-23.742-71.309-31.836-78.267-45.351-21.091-45.351-21.091l-6.082,10.865Z",
    transform: "translate(-270.824 -154.272)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(119.624 1.429)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M277.122,264.908h-4.8V138.239s1.566,2.873,7.29,8.675c7.159,7.257,13.291,18.208,13.291,18.208l-12.925-2.5,16.791,16.9Z",
    transform: "translate(-272.325 -138.239)",
    fill: "#8fa7d7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(48.294 1.318)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M196.786,146.76c-7.159,7.257-13.291,18.208-13.291,18.208l12.925-2.5-16.79,16.9,14.254,61.947-13.183-3.8-7.117-30.554s2.7,26.8,1.888,33.008l1.868.8c.045.543.1,1.084.13,1.628a1.609,1.609,0,0,1-.4,1.2,50.852,50.852,0,0,0,18.92,6.887l3.286,14.279h4.8V138.085S202.509,140.958,196.786,146.76Z",
    transform: "translate(-173.583 -138.085)",
    fill: "#8fa7d7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(78.575 3.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M227.78,168.6l8.264-14.354L215.5,141.511Z",
    transform: "translate(-215.501 -141.511)",
    fill: "#bf7a00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(99.118 2.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M252.786,168.136l-8.848-14.354,20.941-13.951Z",
    transform: "translate(-243.939 -139.831)",
    fill: "#bf7a00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(99.116 5.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M251.886,165.2l-7.949-10.353,17.7-11.18Z",
    transform: "translate(-243.937 -143.667)",
    fill: "#fe9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(81.418 5.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M229.186,165.2l7.949-10.353-17.7-11.18Z",
    transform: "translate(-219.437 -143.667)",
    fill: "#fe9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(116.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M273.233,262.929h-4.8V136.261s2.908,1.247,8.631,7.049c7.159,7.257,11.95,19.834,11.95,19.834l-12.925-2.5,16.79,16.9Z",
    transform: "translate(-268.436 -136.261)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(56.98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M205.255,262.929h4.8V136.261s-2.907,1.247-8.63,7.049c-7.16,7.257-11.95,19.834-11.95,19.834l12.925-2.5-16.791,16.9Z",
    transform: "translate(-185.607 -136.261)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(156.958 70.189)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M330.194,270.609l26.847-32.584-26.7,28.1c.568-15.82,1.48-32.707,1.48-32.707l-7.821,62.4,6.22-3.228C329.742,290.256,329.861,281.069,330.194,270.609Z",
    transform: "translate(-324.005 -233.422)",
    fill: "#8fa7d7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(29.408 95.81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M218.666,299.748H147.44V268.89l69.111,19.921a2.925,2.925,0,0,1,2.114,2.81Z",
    transform: "translate(-147.44 -268.89)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(137.717 81.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M315.427,268.446l-8.323,4.937a.622.622,0,0,1-.621.007l-8.8-4.946a.62.62,0,0,1-.316-.541V249.462a.621.621,0,0,1,.621-.621H315.11a.621.621,0,0,1,.621.621v18.45A.619.619,0,0,1,315.427,268.446Z",
    transform: "translate(-297.371 -248.841)",
    fill: "#d5e1ed"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(137.717 85.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M315.427,269.878l-8.323,4.937a.622.622,0,0,1-.621.007l-8.8-4.946a.621.621,0,0,1-.316-.541V254.62a.622.622,0,0,1,.621-.621H315.11a.622.622,0,0,1,.621.621v14.724A.619.619,0,0,1,315.427,269.878Z",
    transform: "translate(-297.371 -253.999)",
    fill: "#b8ddff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(163.969 64.763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M372.561,295.4l-38.85-27.879,33.177-40.659a2.283,2.283,0,0,1,2.981-.636c1.006.647,1.329,2,7.752,5.487s9.33,3.1,10.38,3.626a2.435,2.435,0,0,1,1.245,2.859Z",
    transform: "translate(-333.711 -225.912)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(98.883 23.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M245.232,169a.809.809,0,1,1-.81-.809A.81.81,0,0,1,245.232,169Z",
    transform: "translate(-243.613 -168.192)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(98.883 48.254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M245.232,203.867a.809.809,0,1,1-.81-.809A.81.81,0,0,1,245.232,203.867Z",
    transform: "translate(-243.613 -203.058)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(98.883 76.248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 0.809,
    cy: 0.809,
    r: 0.809,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(98.883 101.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M245.232,277.485a.809.809,0,1,1-.81-.81A.809.809,0,0,1,245.232,277.485Z",
    transform: "translate(-243.613 -276.675)",
    fill: "#fff"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6",
    transform: "translate(96.415 11.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(52.029 32.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M280.977,99.088c-1.862,6.712-5.152,11.854-6.58,11.459,0,0,1.006-4.274,2.346-11.11,1.555-7.929,1.775-13.52,5.02-13.219C283.238,86.354,282.838,92.375,280.977,99.088Z",
    transform: "translate(-274.397 -86.206)",
    fill: "#f0ba92"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(52.029 33.556)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M278.482,96.7c-1.693,6.757-2.658,14.632-4.085,14.236,0,0,1.423-6.1,2.764-12.931,1.555-7.929,1.4-10.671,4.641-10.37C281.8,87.637,280.54,88.493,278.482,96.7Z",
    transform: "translate(-274.397 -87.614)",
    fill: "#d88d64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(0 32.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M204.057,99.088c1.862,6.712,4.953,11.9,6.38,11.5,0,0-1.518-5.537-2.42-11.355-1.238-7.985-1.5-13.317-4.747-13.016C201.8,86.354,202.2,92.375,204.057,99.088Z",
    transform: "translate(-202.374 -86.205)",
    fill: "#f0ba92"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(0.658 33.599)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M205.8,95.99c1.694,6.757,3.46,15.41,4.888,15.014,0,0-1.518-6.955-2.859-13.791-1.555-7.93-1.3-9.811-4.547-9.51C203.285,87.7,203.745,87.782,205.8,95.99Z",
    transform: "translate(-203.285 -87.674)",
    fill: "#d88d64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(12.326 65.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M254.834,140.238l-17.7,11.18-17.7-11.18v-8.923h35.4Z",
    transform: "translate(-219.437 -131.316)",
    fill: "#f0ba92"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(12.326 59.964)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M254.834,133.48c-3.2,6.676-15.678,10.794-17.7,10.794s-12.641-3.038-17.7-10.819v-9.284h35.4Z",
    transform: "translate(-219.437 -124.171)",
    fill: "#d88d64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190",
    transform: "translate(31.542 187.316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M300.04,308.512h-54v-5.666l25.128-2.337a11.182,11.182,0,0,1,3.142.152l26,5a1.44,1.44,0,0,1,1.168,1.414h0A1.44,1.44,0,0,1,300.04,308.512Z",
    transform: "translate(-246.037 -300.462)",
    fill: "#ffcca9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192",
    transform: "translate(131.393 85.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M409.713,183.622a2.505,2.505,0,0,0-1.881-.5l.075-.1a2.512,2.512,0,0,0-3.535-3.516l1.241-1.61a2.512,2.512,0,0,0-3.705-3.371l6.725-11.648a2.563,2.563,0,0,0-4.391-2.642l-6.269,10c-2.218,3.538-6.118,7.886-9.086,11.8a10.336,10.336,0,0,0-1.857,4c-.015.061-.025.122-.038.183-.049.23-.093.462-.129.693-.005.038-.016.074-.021.112l.005,0a35.318,35.318,0,0,0,.22,8.035c.4,4.654-2.807,13.027-2.807,13.027,5.8,6.947,15.42,8.219,15.42,8.219s.944-3.3,1.848-6.138,5.138-9.456,6.988-15.716c1.407-4.765,2.011-7.939,2.011-7.939s-.017.023-.024.037A2.51,2.51,0,0,0,409.713,183.622Z",
    transform: "translate(-384.259 -159.039)",
    fill: "#ffcca9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194",
    transform: "translate(148.08 110.291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M416.652,193.837a2.547,2.547,0,0,1-.316,2.786l-4.417,5.733a2.207,2.207,0,0,1-3.936-1.064,2.171,2.171,0,0,1,.025-.664,5.368,5.368,0,0,1-.649.437,2.921,2.921,0,0,0,.009.307,2.828,2.828,0,0,0,2.8,2.465,2.767,2.767,0,0,0,.369-.024,2.811,2.811,0,0,0,1.876-1.079L416.829,197A2.677,2.677,0,0,0,416.652,193.837Z",
    transform: "translate(-407.358 -193.837)",
    fill: "#d88d64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(144.228 107.077)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M412.592,191.263l-5.99,7.776a2.206,2.206,0,0,1-3.495-2.694l1.552-2.014a1.3,1.3,0,0,1-.045-.123l0,.005a3.215,3.215,0,0,1-.912.762,1.9,1.9,0,0,1-.454.175l-.628.816a2.827,2.827,0,0,0,4.48,3.451l5.99-7.776a2.844,2.844,0,0,0,.221-2.253A2.833,2.833,0,0,1,412.592,191.263Z",
    transform: "translate(-402.027 -189.388)",
    fill: "#d88d64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(141.936 102.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M410.167,183.468c-1.156,1.781-6.74,8.8-6.74,8.8a2.207,2.207,0,0,1-3.495-2.695l.967-1.256c-.422.21-.846.418-1.269.628l-.191.249a2.828,2.828,0,0,0,2.234,4.554,2.643,2.643,0,0,0,.369-.025,2.805,2.805,0,0,0,1.877-1.078s5.605-7.194,5.838-7.577A4.7,4.7,0,0,0,410.167,183.468Z",
    transform: "translate(-398.854 -183.468)",
    fill: "#d88d64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(134.612 100.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M403.278,180.9a3.093,3.093,0,0,0-2.365-.829l-2.089.183a5.771,5.771,0,0,0-3.164,1.313c.23.057,2.3-.613,3.218-.694l2.088-.183a2.427,2.427,0,0,1,2.636,2.51c-.049,1.35-.593,1.7-3.347,2.874a115.3,115.3,0,0,0-11.54,6.788c1.968-1.093,9.419-5.21,11.782-6.218,2.718-1.158,3.66-1.649,3.725-3.421A3.049,3.049,0,0,0,403.278,180.9Z",
    transform: "translate(-388.715 -180.065)",
    fill: "#d88d64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(1.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M255.01,98.042c-5.9,19.385-22,19.71-22,19.71s-17.012-.046-22.1-20.173c-3.353-13.28-11.424-33.617-1.749-48.688,5.476-8.529,45.291-11.938,49.981,0S258.469,86.675,255.01,98.042Z",
    transform: "translate(-204.56 -41.163)",
    fill: "#ffcca9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(20.892 55.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M249.223,118.809c.651.544-1.358,7.556-8.644,7.631-6.182.064-9.281-6.29-8.721-7.236.692-1.173,3.155-.381,8.472-.381S248.514,118.217,249.223,118.809Z",
    transform: "translate(-231.433 -118.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M240.351,126.664a9.736,9.736,0,0,1-8.248-5.005c-.558-.967-1.034-2.2-.695-2.777.566-.96,1.886-.877,4.289-.727,1.193.076,2.677.169,4.494.169,2.172,0,3.91-.1,5.308-.181,2.192-.124,3.291-.19,3.817.251h0c.5.417.116,1.686-.072,2.213a9.2,9.2,0,0,1-8.8,6.057Zm-6.694-7.879c-.868,0-1.417.108-1.627.464a4.252,4.252,0,0,0,.928,2.423,9.058,9.058,0,0,0,7.392,4.27h.088a8.464,8.464,0,0,0,7.32-3.946,5.538,5.538,0,0,0,1.067-3.067,9.444,9.444,0,0,0-3.283-.063c-1.407.081-3.158.182-5.35.182-1.84,0-3.337-.095-4.54-.17C234.864,118.827,234.2,118.785,233.656,118.785Z",
    transform: "translate(-231.294 -118.05)",
    fill: "#d3976e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(28.41 40.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M243.342,106.861a3.565,3.565,0,0,1-1.409-4.268,25.98,25.98,0,0,0,.756-5.765l.722.016a26.126,26.126,0,0,1-.793,5.981,2.844,2.844,0,0,0,1.146,3.449Z",
    transform: "translate(-241.701 -96.828)",
    fill: "#d88d64"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(0 206.842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M307.269,320.145H72.806c-1.747,0-5.162-8.823-3.413-8.823h241.47C312.61,311.322,309.018,320.145,307.269,320.145Z",
    transform: "translate(-68.908 -311.322)",
    fill: "#265192"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(86.186 92.766)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(0 12.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M200.666,189.919l.316-19.333-1.619.313-.316,19.142c-8.758,1.5-10.512,17.054-10.812,36.889l0,.009-.025,1.108c0,4.05,2.156,5.061,4.906,5.488a24.256,24.256,0,0,0,3.029.246,1.65,1.65,0,0,0,3.16-.667v-1.349a1.653,1.653,0,0,0-1.653-1.652,1.632,1.632,0,0,0-1.607,1.427c-2.194-.109-4.9-.581-5.779-2.2-.857-1.584-.358-4.944-.282-7.212.581-17.344,2.464-30.526,10.513-30.526s11.8,13.146,12.382,30.454c.074,2.174.452,5.362-.36,6.982-.735,1.468-2.715,2.114-4.683,2.381a1.649,1.649,0,0,0-3.228.631l.162,1.339a1.651,1.651,0,0,0,3.234.23c3.154-.436,6.726-1.831,6.611-5.966l-.02-1.625c.006-.025.014-.05.02-.075C214.226,205.67,210.267,190.117,200.666,189.919Z",
    transform: "translate(-188.214 -170.586)",
    fill: "#0e3368"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(70.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M306.3,200.776c-1.63-38.311-19.406-47.014-20.166-47.368,0,0,1.029.818,5.486,6.987,4.642,6.426,11.848,18,12.821,40.429a7.864,7.864,0,1,0,1.859-.048Z",
    transform: "translate(-286.129 -153.408)",
    fill: "#0e3368"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12",
    "data-name": "Layer 12",
    transform: "translate(83.948 87.428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(0 35.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M211.52,230.656c-.4-20.409-3.451-35.9-13.2-35.9-9.906,0-12.867,16-13.182,36.883l0,.009-.024,1.107c0,4.05,2.156,5.061,4.906,5.489a24.259,24.259,0,0,0,3.029.245,1.649,1.649,0,0,0,3.159-.667v-1.349a1.653,1.653,0,0,0-1.652-1.653,1.634,1.634,0,0,0-1.607,1.427c-2.194-.109-4.9-.582-5.778-2.2-.857-1.584-.358-4.945-.282-7.213.581-17.344,3.4-30.389,11.449-30.389s10.86,13.009,11.446,30.317c.074,2.174.451,5.362-.361,6.982-.735,1.469-2.715,2.114-4.683,2.381a1.649,1.649,0,0,0-3.228.632l.163,1.339a1.651,1.651,0,0,0,3.234.23c3.154-.437,6.725-1.832,6.611-5.967l-.021-1.625C211.506,230.706,211.514,230.681,211.52,230.656Z",
    transform: "translate(-185.116 -194.755)",
    fill: "#383f47"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(11.769 18.06)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M203.026,189.009h-1.619V171.333l1.619-.313Z",
    transform: "translate(-201.407 -171.019)",
    fill: "#383f47"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    transform: "translate(68.847 0.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M298.762,194.254c-.836-22.947-8.161-34.711-12.856-41.212-4.457-6.169-5.486-6.987-5.486-6.987.764.357,18.784,9.159,20.2,48.131Z",
    transform: "translate(-280.42 -146.055)",
    fill: "#383f47"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(68.821 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M299.793,194.677c-1.248-23.861-6.947-34.312-11.644-40.812-4.456-6.17-7.766-7.846-7.766-7.846.765.357,18.81,9.891,20.231,48.862Z",
    transform: "translate(-280.384 -146.019)",
    fill: "#1a2026"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(77.096 44.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 7.892,
    cy: 7.892,
    r: 7.892,
    transform: "translate(0 11.16) rotate(-45)",
    fill: "#bcbcbc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220",
    transform: "translate(3.04 3.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M304.166,227.5a8.122,8.122,0,1,1,8.121-8.121A8.131,8.131,0,0,1,304.166,227.5Zm0-15.784a7.662,7.662,0,1,0,7.662,7.662A7.671,7.671,0,0,0,304.166,211.714Z",
    transform: "translate(-296.046 -211.255)",
    fill: "#444"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(90.177 52.469)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M311.94,228.57l-1.993-4.193,1.407-3.863,4.353-1.863s2.541,5.583-3.767,9.919Z",
    transform: "translate(-309.947 -218.651)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(84.702 52.094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 3.548,
    cy: 3.727,
    rx: 3.548,
    ry: 3.727,
    fill: "#635b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(80.055 47.078)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M302.889,211.188l.436,4.789-2.656,3.138-4.729.243s-.469-6.281,6.949-8.17Z",
    transform: "translate(-295.935 -211.188)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230",
    transform: "translate(84.873 51.865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228",
    transform: "translate(0.23 0.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M309.229,221.286a3.153,3.153,0,1,1-3.153-3.154A3.153,3.153,0,0,1,309.229,221.286Z",
    transform: "translate(-302.922 -218.132)",
    fill: "#d3d3d3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M305.987,224.58a3.383,3.383,0,1,1,3.383-3.382A3.387,3.387,0,0,1,305.987,224.58Zm0-6.307a2.924,2.924,0,1,0,2.924,2.924A2.928,2.928,0,0,0,305.987,218.274Z",
    transform: "translate(-302.604 -217.815)",
    fill: "#a8a6a0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232",
    transform: "translate(87.01 54.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 1.239,
    cy: 1.239,
    r: 1.239,
    fill: "#bababa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "translate(87.01 54.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 1.239,
    cy: 1.239,
    r: 1.239,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236",
    transform: "translate(8.396 75.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16987",
    "data-name": "Rectangle 16987",
    width: 1.364,
    height: 3.193,
    rx: 0.446,
    fill: "#aaa9a2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(17.355 75.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16988",
    "data-name": "Rectangle 16988",
    width: 1.364,
    height: 3.193,
    rx: 0.446,
    transform: "translate(0 0.128) rotate(-5.386)",
    fill: "#aaa9a2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    transform: "translate(85.502 52.541)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M305.418,218.751a2.749,2.749,0,0,0-1.943,2.285l1.771.131.468-.468Z",
    transform: "translate(-303.475 -218.751)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(88.993 54.746)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M309.258,224.619a2.749,2.749,0,0,0,1.033-2.816l-1.707.491-.277.6Z",
    transform: "translate(-308.307 -221.803)",
    fill: "#fff"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4",
    transform: "translate(96.415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244",
    transform: "translate(0 15.085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M206.734,85.881s-3.4-13.49-4.011-20.3S201.4,49.616,209.076,46.5s5.315,6.4,5.315,6.4-6.07,4.082-7.284,14.3C206.447,72.755,206.734,85.881,206.734,85.881Z",
    transform: "translate(-202.374 -45.876)",
    fill: "#2a445d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    transform: "translate(47.757 15.085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M276.109,85.676s3.778-13.286,4.386-20.1,1.323-15.961-6.353-19.076-5.315,6.4-5.315,6.4,6.07,4.082,7.285,14.3C276.77,72.755,276.109,85.676,276.109,85.676Z",
    transform: "translate(-268.483 -45.876)",
    fill: "#2a445d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248",
    transform: "translate(6.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M254.012,50.371s-9.351,1.491-15.617-1.453c-1.836-.863-10.743,2.927-14.837,2.162a16.023,16.023,0,0,1-11.433-8.5c-.451-1.919-2.327-4.654,3.339-8.9,7.837-5.878,17.5-4.452,19.122-6.172a6.8,6.8,0,0,1,6.374-2.458c8.4.839,8.809,5.767,13.532,6.505,6.147.962,8.221,3.44,8.62,8.6C263.872,49.971,254.012,50.371,254.012,50.371Z",
    transform: "translate(-211.467 -24.993)",
    fill: "#2a445d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(11.275 1.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M238.015,26.652s-2.631,1.888-9.241,9.578-10.05,7.217-10.792,7.352c0,0,5.7.984,11.736-6.947S238.015,26.652,238.015,26.652Z",
    transform: "translate(-217.982 -26.652)",
    fill: "#1f384c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    transform: "translate(41.678 20.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M260.068,58.061S271.1,59.364,275.9,53.6c0,0-1.012,6.026-15.581,4.559Z",
    transform: "translate(-260.068 -53.603)",
    fill: "#1f384c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    transform: "translate(6.874 14.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M228.558,55.717c-13,1.816-16.731-8.91-16.668-8.711,2.047,6.507,7.22,9.013,11.006,9.987a17.1,17.1,0,0,0,3.384.577c.612.048.989.046.989.046l.024-.006c12.427.108,22.487-13.033,22.487-13.033C241.345,51.837,233.864,54.671,228.558,55.717Z",
    transform: "translate(-211.889 -44.578)",
    fill: "#1f384c"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5",
    transform: "translate(98.107 37.391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257",
    transform: "translate(13.271 6.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M233.107,99.837l4.294-4.294v4.294Z",
    transform: "translate(-225.869 -88.306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M224.6,96.85l-2.25-2.25V89.076l4.294-4.294h5.524l2.251,2.25v5.524l-4.294,4.294Z",
    transform: "translate(-222.882 -85.319)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M226.638,84.782l-4.294,4.294V84.782Z",
    transform: "translate(-222.882 -85.319)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260",
    transform: "translate(32.873 6.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M260.242,100.365l4.294-4.294v4.294Z",
    transform: "translate(-253.004 -88.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M251.73,97.377l-2.25-2.25V89.6l4.294-4.294H259.3l2.251,2.25v5.524l-4.294,4.294Z",
    transform: "translate(-250.016 -85.846)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M253.773,85.309,249.48,89.6V85.309Z",
    transform: "translate(-250.016 -85.846)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262",
    transform: "translate(37.352 0.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M263.1,80.962a7.312,7.312,0,0,0-5.335-1.3,1.184,1.184,0,0,1-1.305-1.453h0a1.178,1.178,0,0,1,.778-.863,6.972,6.972,0,0,1,7.423,1.741,1.174,1.174,0,0,1,.277,1.081l-.018.077A1.186,1.186,0,0,1,263.1,80.962Z",
    transform: "translate(-256.423 -76.952)",
    fill: "#2a445d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(17.377 10.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(19.609 0.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M257.307,91.121a1.822,1.822,0,1,0,1.391,1.771A1.616,1.616,0,0,0,257.307,91.121Z",
    transform: "translate(-255.916 -91.121)",
    fill: "#210601"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M230.163,90.922a1.822,1.822,0,1,0,1.391,1.771A1.616,1.616,0,0,0,230.163,90.922Z",
    transform: "translate(-228.772 -90.922)",
    fill: "#210601"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(0 6.13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M248.658,89.456a5.844,5.844,0,0,0-11.349.9l-.006,0a5.517,5.517,0,0,0-8.05-.317,5.851,5.851,0,0,0-11.332-.732c-9.763-3.458-12.169-3.912-12.814-3.791-.193.036-.358.325-.39.485l.5.2a.882.882,0,0,1,.1-.126c.848-.1,6.918,1.877,12.416,3.821a5.859,5.859,0,0,0,10.821,4.124,1.693,1.693,0,0,0,.5-.168,1.583,1.583,0,0,0,.455-.34,1.865,1.865,0,0,0,.459-1,2.833,2.833,0,0,0-.344-1.968,4.894,4.894,0,0,1,7.257.259,2.946,2.946,0,0,0-.272,1.852,1.854,1.854,0,0,0,.459,1,1.582,1.582,0,0,0,.455.34,1.671,1.671,0,0,0,.5.168,5.86,5.86,0,0,0,10.82-4.124c5.58-1.976,11.644-3.992,12.335-3.825-.023-.006.624-.256.624-.256C261.608,85.557,261.344,84.962,248.658,89.456ZM223.485,96.37a5.255,5.255,0,1,1,5.256-5.255A5.26,5.26,0,0,1,223.485,96.37Zm5.857-3.55a1.076,1.076,0,0,1-.251.347,1.044,1.044,0,0,1-.146.088,5.822,5.822,0,0,0,.4-1.961,1.217,1.217,0,0,1,.125.344A2.479,2.479,0,0,1,229.342,92.82Zm8.147.491a1.094,1.094,0,0,1-.252-.346,2.49,2.49,0,0,1-.126-1.183,1.22,1.22,0,0,1,.126-.345,5.834,5.834,0,0,0,.4,1.963A.99.99,0,0,1,237.489,93.311Zm5.605,3.2a5.255,5.255,0,1,1,5.255-5.255A5.26,5.26,0,0,1,243.094,96.513Z",
    transform: "translate(-204.717 -85.238)",
    fill: "#302420"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    transform: "translate(11.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M222.161,80.763a7.311,7.311,0,0,1,5.334-1.3A1.184,1.184,0,0,0,228.8,78.01h0a1.176,1.176,0,0,0-.777-.863,6.972,6.972,0,0,0-7.423,1.741,1.173,1.173,0,0,0-.277,1.081l.018.077A1.187,1.187,0,0,0,222.161,80.763Z",
    transform: "translate(-220.29 -76.753)",
    fill: "#2a445d"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16",
    "data-name": "Layer 16",
    transform: "translate(83.993 85.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    transform: "translate(24.748)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M233.93,159.022l-14.493-15.355,9.749,21.533,2.309-3.007h0Z",
    transform: "translate(-219.437 -143.667)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275",
    transform: "translate(48.087)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M263.8,143.667,254.053,165.2l-2.309-3.007h0Z",
    transform: "translate(-251.744 -143.667)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278",
    transform: "translate(46.725 19.373)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M249.86,170.485l.022,96.257h.621V171.666Z",
    transform: "translate(-249.86 -170.485)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(1.441 37.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M187.252,231.786s-1.532-31.159,8.989-35.206a7.539,7.539,0,0,1,6.307.506c5.573,2.938,6.958,13.606,7.386,18.447.554,6.273,1.409,15.4.3,17.951,0,0,.392-14.493-2.036-25.066s-7.007-11.734-9.932-11.571-6.33,3.446-8.229,9.851S187.252,231.786,187.252,231.786Z",
    transform: "translate(-187.174 -196.105)",
    fill: "#1a2026"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(0 75.857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M185.179,248.678a5.191,5.191,0,0,0,3.528,3.4,4.552,4.552,0,0,0,4.261-.86,5.99,5.99,0,0,0,.1,2.241S185.428,254.278,185.179,248.678Z",
    transform: "translate(-185.179 -248.675)",
    fill: "#1a2026"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284",
    transform: "translate(19.579 73.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M219.052,245.738a5.186,5.186,0,0,1-.444,2.391,4.716,4.716,0,0,1-2.9,2.6c-2.539,1.343-3.43-.451-3.43-.451a7.576,7.576,0,0,1,.168,2.2S219.619,252.244,219.052,245.738Z",
    transform: "translate(-212.282 -245.736)",
    fill: "#1a2026"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(11.723 19.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M201.407,171.333l1.619-.313-.1.826-1.518.294Z",
    transform: "translate(-201.407 -171.019)",
    fill: "#1a2026"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    transform: "translate(86.184 209.248)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16989",
    "data-name": "Rectangle 16989",
    width: 78.418,
    height: 1.645,
    rx: 0.822,
    fill: "#588ac4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardDoctor);
export default __webpack_public_path__ + "static/media/dashboard_doctor.c3328d2b9c860394b4c33533d54aba30.svg";
export { ForwardRef as ReactComponent };